import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/account',
  name: 'publicAccount',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/account',
      component: () => import('@/views/operation/accountManage/index.vue'),
      meta: {
        title: '公众号',
        icon: 'qiyehao'
      }
    },
    {
      path: '/operation/account/detail/:accountId',
      name: 'accountInfo',
      component: () => import('@/views/operation/accountManage/account-message.vue'),
      meta: { title: '公众号详情' }
    },
    {
      path: '/operation/account/messageManage/:accountId/:path/:accountName',
      name: 'accountGreet',
      component: () => import('@/views/operation/accountManage/greeting-manage'),
      meta: { title: '回复消息管理' }
    },
    {
      path: '/operation/account/menuManage/:accountId/:path/:accountName',
      name: 'accountMenuManage',
      component: () => import('@/views/operation/accountManage/menu-manage'),
      meta: { title: '公众号菜单管理' }
    },
    {
      path: '/operation/account/templateManage/:accountId/:path/:accountName',
      name: 'accountTemplateManage',
      component: () => import('@/views/operation/accountManage/template-manage'),
      meta: { title: '模板消息管理' }
    }
  ]
}
